import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./i18n";
import { initPostHog } from "./lib/posthog";
import { ErrorBoundary } from "@/components/error-boundary";

// Initialize PostHog
initPostHog();

// react-grab: kopiowanie elementów UI z kontekstem źródłowym dla agentów AI.
// Tylko dev + jawny opt-in przez REACT_GRAB=true w .env; w buildzie produkcyjnym
// gałąź jest usuwana (DEV=false), więc pakiet nie trafia do bundla.
if (import.meta.env.DEV && __REACT_GRAB__) {
  import("react-grab");
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
